import { useState } from 'react';
import { calculateTimeSlot } from '../slice/lucket-model/model';
import { TimeOptionsLabel } from '../constants';

/**
 * Custom hook to manage time slot open/close state
 */
export const useTimeSlots = () => {
    const [openTimes, setOpenTimes] = useState({
        LN: calculateTimeSlot(new Date()) == TimeOptionsLabel[0],
        DN: calculateTimeSlot(new Date()) == TimeOptionsLabel[1],
        EM: calculateTimeSlot(new Date()) == TimeOptionsLabel[2],
        MO: calculateTimeSlot(new Date()) == TimeOptionsLabel[3],
        NO: calculateTimeSlot(new Date()) == TimeOptionsLabel[4],
        AF: calculateTimeSlot(new Date()) == TimeOptionsLabel[5],
        EV: calculateTimeSlot(new Date()) == TimeOptionsLabel[6],
        NI: calculateTimeSlot(new Date()) == TimeOptionsLabel[7],
    });

    const expandAllTimes = () => {
        setOpenTimes({
            LN: true,
            DN: true,
            EM: true,
            MO: true,
            NO: true,
            AF: true,
            EV: true,
            NI: true,
        });
    };

    const collapseAllTimes = () => {
        setOpenTimes({
            LN: false,
            DN: false,
            EM: false,
            MO: false,
            NO: false,
            AF: false,
            EV: false,
            NI: false,
        });
    };

    return { openTimes, setOpenTimes, expandAllTimes, collapseAllTimes };
};
